import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { QuestionsService } from '../../services/questions.service';
import { Proposition, Question } from '../../interfaces/question.type';
import { ActivatedRoute } from '@angular/router';
import { core } from '@angular/compiler';
import { Quiz } from '../../interfaces/quiz.type';
import { CategoryQuizService } from '../../services/category-quiz.service';
import { CategoryQuestionService } from '../../services/category-question.service';
import { NiveauQuestionService } from '../../services/niveau-question.service';

@Component({
  selector: 'app-question-editor-bulk',
  templateUrl: './question-editor-bulk.component.html',
  styleUrls: ['./question-editor-bulk.component.scss'],
})
export class QuestionEditorBulkComponent implements OnInit, OnChanges {
  @Input({ required: true }) question: Question;
  @Input({ required: true }) questionIndex!: number;

  allQuestions: any;
  editableLabel: boolean = false;
  correspondingQuiz: Quiz;
  editableTheme: boolean = false;
  initAnswerMode: Proposition;
  id: string;
  questionData: any;
  categoryList: any;
  levelList: any;
  currentLevel: any;
  selectedCategory: any;

  constructor(
    private questions: QuestionsService,
    private router: ActivatedRoute,
    private category: CategoryQuestionService,
    private niveauQuestion: NiveauQuestionService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question']) {
      // Actualiser le theme a chaque update question
      if (typeof this.question.theme !== 'object') {
        this.category.getAllQuestionCategories().subscribe({
          next: (data) => {
            this.categoryList = data;
            this.question.theme = data[Math.floor(Math.random() * data.length)];
            console.log('les categories disponible :', data);
          },
        });
      } else {
        console.log('theme deja definie');
      }

      if (!Array.isArray(this.question.imgObj)) {
        this.question.tempImg = [];
        this.question.imgObj = [];
        this.question.imgList = [];
      }

      this.niveauQuestion.getAllLevels().subscribe({
        next: (data) => {
          this.levelList = data.sort();
          this.currentLevel = data[Math.floor(Math.random() * data.length)];
          // Actualiser la difficulté
          // this.currentLevel = data.filter(
          //   (level: any) => level.niveauquestionid === this.question.difficulte
          // )[0];
          console.log('niveau disponible :', data.sort());
        },
      });
    }
  }

  ngOnInit(): void {
    this.id = this.router.snapshot.paramMap.get('id');
    let urlIdData = JSON.parse(this.router.snapshot.paramMap.get('data'));
    this.questionData = urlIdData;
    console.log('Question courante: ', this.question);

    this.niveauQuestion.getAllLevels().subscribe({
      next: (data) => {
        this.levelList = data.sort();
        this.currentLevel = data[Math.floor(Math.random() * data.length)];
        this.question.difficulte = data[Math.floor(Math.random() * data.length)].niveauquestionid;
        console.log('Niveau choisit aleatoirement :', this.currentLevel );
      },
    });
    
    

    this.category.getAllQuestionCategories().subscribe({
      next: (data) => {
        this.categoryList = data;
        this.question.theme = data[Math.floor(Math.random() * data.length)];
        console.log('les categories disponible :', data);
      },
    });

    console.log('Nouvelle données et page charger ...');

    this.question.nbreReponse = this.question.proposition.filter(
      (reponse) => reponse.isCorrect === true
    ).length;

    if (this.question.proposition.length === 2) {
      this.question.typeReponse = 'Binaire';
    } else {
      this.question.typeReponse = 'Multiple';
    }
  }

  toggleEditQuestionLabel() {
    this.editableLabel = !this.editableLabel;
  }

  toggleEditQuestionTheme() {
    this.editableTheme = !this.editableTheme;
  }

  changeQuestionLevel(level: any) {
    this.currentLevel = level;
    this.question.difficulte = this.currentLevel.niveauquestionid
    console.log('le current level state: ', this.currentLevel);
  }

  descreaseDifficulty() {
    let b = this.findClosestDifficulty(
      this.levelList,
      this.currentLevel.pointdifficulte - 1
    );

    console.log(b);
  }

  findClosestDifficulty(allLevels: any[], target: number): number {
    let numbers = allLevels.map((niveau) => niveau.pointdifficulte);
    let closestNumber = numbers[0];
    let closestDistance = Math.abs(numbers[0] - target);

    for (let i = 1; i < numbers.length; i++) {
      const distance = Math.abs(numbers[i] - target);
      if (distance < closestDistance) {
        closestNumber = numbers[i];
        closestDistance = distance;
      }
    }
    console.log(closestNumber);

    this.currentLevel = allLevels.filter(
      (level) => level.pointdifficulte === closestNumber
    )[0];
    this.question.difficulte = this.currentLevel.niveauquestionid;

    this.question.niveauquestion = this.currentLevel;
    console.log(this.currentLevel);
    return closestNumber;
  }

  increaseDifficulty() {
    // if (this.question.difficulte < 3) {
    //   this.question.difficulte += 1;
    //   console.log('Upm difficulty : ', this.question);
    // }
    let b = this.findClosestDifficulty(
      this.levelList,
      this.currentLevel.pointdifficulte + 1
    );

    this.question.difficulte = this.currentLevel.niveauquestionid;

    console.log(b);
  }

  difficultyStatus(id: number): string {
    let status: string;
    switch (id) {
      case 1:
        status = 'Facile';
        break;
      case 2:
        status = 'Moyen';
        break;
      case 3:
        status = 'Difficile';
        break;

      default:
        break;
    }

    return status;
  }

  toggleAnswerMode($event: any) {
    try {
      console.log('Mode actuel : ', $event);
      if ($event == 'Binaire') {
        this.question.proposition = [
          {
            title: 'Vrai',
            isCorrect: true,
            code: null,
          },
          {
            title: 'Faux',
            isCorrect: false,
            code: null,
          },
        ];
        console.log('deux champs', $event);
      } else {
        console.log('4 champs', $event);
        this.question.proposition = [
          {
            title: '',
            isCorrect: true,
            code: null,
          },
          {
            title: '',
            isCorrect: false,
            code: null,
          },
          {
            title: '',
            isCorrect: false,
            code: null,
          },
          {
            title: '',
            isCorrect: false,
            code: null,
          },
        ];
      }
    } catch (error) {
      console.log(error, $event);
    }
  }

  onCategoryChange($value: any) {
    console.log('Selected category:', $value);
    this.question.theme = $value;
  }

  selectCorrectAnswer(
    proposition: Proposition,
    clickedPropositionIndex: number
  ) {
    console.log('Proposition : ', this.question);

    const propositionIndex = this.question.proposition.indexOf(proposition);

    if (this.question.typeReponse === 'Multiple') {
      if (propositionIndex !== -1) {
        this.question.proposition[propositionIndex] = {
          ...proposition,
          isCorrect: !proposition.isCorrect,
        };
      }
    } else {
      console.log('Le type de reponse est binaire');
      this.question.proposition = this.question.proposition.map(
        (proposition, index) => {
          if (index === clickedPropositionIndex) {
            // Si la proposition cliquée est déjà marquée comme correcte,
            // on la marque comme fausse, et vice versa.
            return {
              ...proposition,
              isCorrect: !proposition.isCorrect,
            };
          } else {
            // Si une autre proposition est marquée comme correcte,
            // on la marque comme fausse.
            return {
              ...proposition,
              isCorrect: false,
            };
          }
        }
      );

      console.log(
        'Hello',
        this.question.proposition.map((proposition, index) => {
          if (proposition.isCorrect) {
            return {
              ...proposition,
              isCorrect: false,
            };
          } else {
            return {
              ...proposition,
              isCorrect: true,
            };
          }
        })
      );
    }

    this.question.nbreReponse = this.question.proposition.filter(
      (reponse) => reponse.isCorrect === true
    ).length;
  }

  // logges les infos a propos de la difficultée:: Debug
  logggesLevelInfo(){
    console.log(this.question);
  }

}
